import { OtherLocale } from '../locales/other-locales';
import { Domain } from './domain';

export const otherHostDomainsForLocale: Record<OtherLocale, Domain[]> = {
  'es-MX': [{ subdomain: 'www', host: 'tiempoyradar.com.mx' }],
  'hi-IN': [{ subdomain: 'www', host: 'mausam.weatherandradar.in' }],
  'id-ID': [{ subdomain: '', host: 'cuacadanradar.com' }],
  'en-ZA': [{ subdomain: '', host: 'weatherandradar.co.za' }],

  // Hint: although there *are* PWAs behind the hostname we provide here, this
  // still belongs to "other mappings" rather than "pwa mappings", because there
  // are no specific PWA instances for these locales. The following cases are
  // more like a fallback. If someone e.g. asks for the hostname of "ta-IN", they'll
  // be falling back to the PWA host of "en-IN" and so on
  'ta-IN': [{ subdomain: 'www', host: 'weatherandradar.in' }],
  'ru-RU': [{ subdomain: 'www', host: 'pogodairadar.ru' }],
  'ru-UA': [{ subdomain: 'www', host: 'pogodairadar.com.ua' }],
  'sr-Cyrl-ME': [{ subdomain: 'www', host: 'vrijemeradar.me' }],
  'sr-Cyrl-RS': [{ subdomain: 'www', host: 'vremeradar.rs' }],
};
